import { Grid, Tooltip} from "@mui/material";

export function getMlmuserStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        userid:{
            name:'userid',
            label:'userid',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        usertype:{
            name:'usertype',
            label:'User Type',
            value:'',
            error:false,
            errorMessage:'You must enter User Type',
            required:true,
            fieldtype:'string'
        },
        mlmusertypeid:{
            name:'mlmusertypeid',
            label:'MLM User Type Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        mlmusertypename:{
            name:'mlmusertypename',
            label:'MLM User Type Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        seniorpartnerid:{
            name:'seniorpartnerid',
            label:'Senior Partner Id',
            value:'',
            error:false,
            errorMessage:'You must enter Senior Partner Id',
            required:true,
            fieldtype:'ID'
        },
        mobilenumber:{
            name:'mobilenumber',
            label:'Mobile Number',
            value:'',
            error:false,
            errorMessage:'You must enter Mobile Number',
            required:true,
            fieldtype:'mobile'
        },
        loginstatus:{
            name:'loginstatus',
            label:'Login Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        membercount:{
            name:'membercount',
            label:'Member Count',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        pan:{
            name:'pan',
            label:'PAN',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        pkgid:{
            name:'pkgid',
            label:'pkgId',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        paymentid:{
            name:'paymentid',
            label:'paymentId',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        paymentamount:{
            name:'paymentamount',
            label:'paymentAmount',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        couponcode:{
            name:'couponcode',
            label:'couponCode',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        paymentorderid:{
            name:'paymentorderid',
            label:'paymentOrderId',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        partnershipstatus:{
            name:'partnershipstatus',
            label:'partnershipStatus',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        aadharnumber:{
            name:'aadharnumber',
            label:'Aadhar Number',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        address:{
            name:'address',
            label:'Address ',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        city:{
            name:'city',
            label:'City',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        pincode:{
            name:'pincode',
            label:'Pin Code',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        kitdelivered:{
            name:'kitdelivered',
            label:'Kit Delivered',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'boolean'
        },
        incomerangeid:{
            name:'incomerangeid',
            label:'Income Range Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        paymentstatus:{
            name:'paymentstatus',
            label:'Payment Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        razcontactid:{
            name:'razcontactid',
            label:'Raz Contact Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        razfundaccountid:{
            name:'razfundaccountid',
            label:'Raz Fund Account Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        fundaccountvalidated:{
            name:'fundaccountvalidated',
            label:'Fund Account Validated',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'boolean'
        },
        invitesenton:{
            name:'invitesenton',
            label:'Invite Sent On',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:150 },
        { field: 'userid', headerName: 'userid', width:150 },
        { field: 'usertype', headerName: 'User Type', width:150 },
        { field: 'mlmusertypeid', headerName: 'MLM User Type Id', width:150 },
        { field: 'mlmusertypename', headerName: 'MLM User Type Name', width:150 },
        { field: 'seniorpartnerid', headerName: 'Senior Partner Id', width:150 },
        { field: 'mobilenumber', headerName: 'Mobile Number', width:150 },
        { field: 'loginstatus', headerName: 'Login Status', width:150 },
        { field: 'membercount', headerName: 'Member Count', width:150 },
        { field: 'pkgid', headerName: 'pkgId', width:150 },
        { field: 'paymentid', headerName: 'paymentId', width:150 },
        { field: 'paymentamount', headerName: 'paymentAmount', width:150 },
        { field: 'couponcode', headerName: 'couponCode', width:150 },
        { field: 'paymentorderid', headerName: 'paymentOrderId', width:150 },
        { field: 'partnershipstatus', headerName: 'partnershipStatus', width:150 },
        { field: 'aadharnumber', headerName: 'Aadhar Number', width:150 },
        { field: 'kitdelivered', headerName: 'Kit Delivered', width:150 },
        { field: 'incomerangeid', headerName: 'Income Range Id', width:150 },
        { field: 'paymentstatus', headerName: 'Payment Status', width:150 },
        { field: 'razcontactid', headerName: 'Raz Contact Id', width:150 },
        { field: 'razfundaccountid', headerName: 'Raz Fund Account Id', width:150 },
        { field: 'fundaccountvalidated', headerName: 'Fund Account Validated', width:150 },
        { field: 'invitesenton', headerName: 'Invite Sent On', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['userid']:{
          ...formValues['userid'],
          value:data.userid,
        },['usertype']:{
          ...formValues['usertype'],
          value:data.usertype,
        },['mlmusertypeid']:{
          ...formValues['mlmusertypeid'],
          value:data.mlmusertypeid,
        },['mlmusertypename']:{
          ...formValues['mlmusertypename'],
          value:data.mlmusertypename,
        },['seniorpartnerid']:{
          ...formValues['seniorpartnerid'],
          value:data.seniorpartnerid,
        },['mobilenumber']:{
          ...formValues['mobilenumber'],
          value:data.mobilenumber,
        },['loginstatus']:{
          ...formValues['loginstatus'],
          value:data.loginstatus,
        },['membercount']:{
          ...formValues['membercount'],
          value:data.membercount,
        },['pan']:{
          ...formValues['pan'],
          value:data.pan,
        },['pkgid']:{
          ...formValues['pkgid'],
          value:data.pkgid,
        },['paymentid']:{
          ...formValues['paymentid'],
          value:data.paymentid,
        },['paymentamount']:{
          ...formValues['paymentamount'],
          value:data.paymentamount,
        },['couponcode']:{
          ...formValues['couponcode'],
          value:data.couponcode,
        },['paymentorderid']:{
          ...formValues['paymentorderid'],
          value:data.paymentorderid,
        },['partnershipstatus']:{
          ...formValues['partnershipstatus'],
          value:data.partnershipstatus,
        },['aadharnumber']:{
          ...formValues['aadharnumber'],
          value:data.aadharnumber,
        },['address']:{
          ...formValues['address'],
          value:data.address,
        },['city']:{
          ...formValues['city'],
          value:data.city,
        },['pincode']:{
          ...formValues['pincode'],
          value:data.pincode,
        },['kitdelivered']:{
          ...formValues['kitdelivered'],
          value:data.kitdelivered,
        },['incomerangeid']:{
          ...formValues['incomerangeid'],
          value:data.incomerangeid,
        },['paymentstatus']:{
          ...formValues['paymentstatus'],
          value:data.paymentstatus,
        },['razcontactid']:{
          ...formValues['razcontactid'],
          value:data.razcontactid,
        },['razfundaccountid']:{
          ...formValues['razfundaccountid'],
          value:data.razfundaccountid,
        },['fundaccountvalidated']:{
          ...formValues['fundaccountvalidated'],
          value:data.fundaccountvalidated,
        },['invitesenton']:{
          ...formValues['invitesenton'],
          value:data.invitesenton,
        },
      })
}